import PolimClient from '../utils/api/PolimClient'

export default class AddProductCart {
    /**
     * @param {{ miId?: string, itemId?: string, itemUrl?: string }} params
     * @param {Function} cb
     */
    static getSourcingItem(params, cb) {
        const { miId, itemId, itemUrl } = params || {}
        let query = ''
        if (miId) {
            query = `?miId=${encodeURIComponent(miId)}`
        } else if (itemUrl) {
            query = `?marketplace=taobao&itemUrl=${encodeURIComponent(itemUrl)}`
        } else if (itemId) {
            query = `?itemId=${encodeURIComponent(itemId)}`
        }
        const baseUrl = (process.env.REACT_APP_PRODUCT || '').replace(/\/+$/, '')
        PolimClient.request(
            {
                endpoint: `${baseUrl}/customer/sourcing/items${query}`,
                method: 'GET',
            },
            cb
        )
    }

    /**
     * Tìm kiếm sản phẩm sourcing theo từ khóa & marketplace
     * @param {{ keyword: string, marketplace?: string } | string} params
     * @param {Function} cb
     */
    static searchSourcingProducts(params, cb) {
        const { keyword, marketplace = 'taobao' } =
            typeof params === 'string' ? { keyword: params, marketplace: 'taobao' } : params || {}
        const queryParams = new URLSearchParams()
        if (keyword) queryParams.append('keyword', keyword)
        if (marketplace) queryParams.append('marketplace', marketplace)

        const baseUrl = (process.env.REACT_APP_PRODUCT || '').replace(/\/+$/, '')
        const cleanBaseUrl = baseUrl.replace(/\/api$/, '')
        const endpoint = `${cleanBaseUrl}/api/customer/sourcing/search?${queryParams.toString()}`

        PolimClient.request(
            {
                endpoint,
                method: 'GET',
            },
            cb
        )
    }

    static getDetailProductTaobao(id, cb) {
        PolimClient.request(
            {
                endpoint: `/customer/taobao/fetch_global_product?itemId=${id}`,
                method: 'GET',
            },
            cb
        )
    }

    static trackingAddToCart() {
        PolimClient.request({
            endpoint: `tenants/current/tracking-add-to-cart`,
            method: 'POST',
        })
    }

    static getDetailProduct1688(id, cb) {
        PolimClient.request(
            {
                endpoint: `/customer/alibaba/fetch_global_product?itemId=${id}`,
                method: 'GET',
            },
            cb
        )
    }

    static getMobileUrlResponse(marketPlace, url, cb) {
        PolimClient.request(
            {
                endpoint: `/customer/${marketPlace}/get-link?shortLink=${url}`,
                method: 'GET',
            },
            cb
        )
    }

    static addToCart(body, cb) {
        PolimClient.request(
            {
                endpoint: `customer/cart/skus`,
                body: body,
                method: 'POST',
            },
            cb
        )
    }
}
